export default {
  state: {
    favoriteProducts: [],
    isFavPage: 0
  },
  setFavoriteProducts (products) {
    this.state.favoriteProducts = products
  },
  getFavoriteProducts () {
    return this.state.favoriteProducts
  },
  setIsFavPage (value) {
    this.state.isFavPage = value
  },
  getIsFavPage () {
    return this.state.isFavPage
  }
}
